import { shouldIntercept } from '@inertiajs/core'
import { router } from '@inertiajs/vue3'

/**
 * Click handler for a real `<a href>` that opens with an Inertia visit, the rule Inertia's <Link> uses.
 * Modifier keys or another button (new tab, new window) are left to the browser.
 * Returns whether the visit was made.
 */
export function visitLink(event: MouseEvent | KeyboardEvent, href: string): boolean {
  // Vuetify turns Enter/Space on a link into a click MouseEvent, so a KeyboardEvent is never a link click.
  if (!(event instanceof MouseEvent) || !shouldIntercept(event)) return false

  event.preventDefault()
  router.visit(href)
  return true
}
